export default "__VITE_PUBLIC_ASSET__8db23f9e__"